export default __webpack_public_path__ + "css/styles.min.css";